import _ from 'lodash'

export const icon = 'arrow-progress'
export const humanName = {
  singular: 'Jornada',
  plural: 'Jornadas'
}
export const SCREENS = {
  INITIAL_SCREEN: 'initial',
  STEPS_SCREEN: 'steps',
  OUT_OF_TIME_SCREEN: 'out_of_time',
  OUT_OF_HEARTS_SCREEN: 'out_of_hearts',
  FINISH_SCREEN: 'finish'
}
export const getConfig = props => {
  const { digitalProductId, journeyId, quizId } = props
  const config = {
    basePath: '/quizzes',
    apiBasePath: `/user/digital_products/${digitalProductId}/quizzes`,
    humanName,
    icon,
    pagination: {
      per_page: 999
    },
    SCREENS
  }

  return config
}
